import { api } from './client';

export type AcquisitionCostDateGrain = 'day' | 'week' | 'month';

export interface AcquisitionCostRow {
  time: string;
  metrics: Record<string, Record<string, number>>;
}

export interface AcquisitionCostResponse {
  list: AcquisitionCostRow[];
  total: number;
  page: number;
  total_page: number;
  start_date: string;
  end_date: string;
  date_grain: AcquisitionCostDateGrain;
}

export interface AcquisitionCostParams {
  brand_id: string;
  site_id: string;
  start_date: string;
  end_date: string;
  date_grain: AcquisitionCostDateGrain;
	page?: number;
	size?: number;
}

export const acquisitionCostApi = {
  getMonitor: (params: AcquisitionCostParams) =>
    api.get<{ code: number; data: AcquisitionCostResponse }>('/acquisition-cost/monitor', { params }),
};
